export const POPOVER_AUTO_CLOSE = 'outside';
